<style>

.submit_info {
    width: 350px;
    display: flex;
    flex-direction: column;
    margin: auto;
}
.submit_title {
    font-family: Gotham Pro, sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 17px;
    text-align: center;
    color: #404455;
    padding-bottom: 20px;
}
.submit_form_inputs {
    margin: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-top: 0;
}
.email_title {
    margin: 0;
    text-align: left;
}
.phone_title {
    margin: 0;
    text-align: left;
}
:global(#user_phone), #user_email, #user_name, #user_comment{
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    /*width: 350px;*/
    height: 40px;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 15px;
    color: #404455;
}
:global(#user_phone::placeholder), #user_email::placeholder, #user_name::placeholder, #user_comment::placeholder {
    color: #E0E0E0;
    opacity: 1;
}

:global(#user_phone:-ms-input-placeholder), #user_email:-ms-input-placeholder, #user_name:-ms-input-placeholder, #user_comment:-ms-input-placeholder {
    color: #E0E0E0;
}

:global(#user_phone::-ms-input-placeholder), #user_email::-ms-input-placeholder, #user_name::-ms-input-placeholder, #user_comment::-ms-input-placeholder {
    color: #E0E0E0;
}

.middle #user_phone, .middle #user_email, .middle #user_name, .middle #user_comment{
    width: 300px;
}
#user_comment {
    height: 130px;
    resize: none;
}
.middle.submit_info{
    width: 300px;
}
button.submit_btn {
    background: #FF0000;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    width: 140px;
    height: 44px;
    margin: auto;
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 17px;
    color: #FFFFFF;
    float: right;
    cursor: pointer;
    transition: 0.25s;
}

button.submit_btn:hover {
    background-color: #DD0000;
    color: #FFFFFF;
}
button.submit_btn:active, button.submit_btn:focus {
    background-color: #ff0000;
    color: #FFFFFF;
    box-shadow: 0 0 0 0.2rem #ff000060;
}
button.submit_btn_prev {
    background: #ffffff;
    color: #FF0000;
    float: left;
    cursor: pointer;
    transition: 0.25s;
}
button.submit_btn_prev:hover {
    background-color: #FF0000;
    color: #FFFFFF;
}
button.submit_btn_prev:active, button.submit_btn_prev:focus {
    background-color: #FF0000;
    color: #FFFFFF;
    box-shadow: 0 0 0 0.2rem #ff000060;
}
.button_container:after {
    content: '';
    display: block;
    clear: both;
}
.submit_form_count_area {
    padding: 20px 0;
}
.submit_form_count_title {
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    color: #404455;
    padding-bottom: 7px;
}
.submit_form_count {
    display: flex;
    align-items: center;
    justify-content: center;
}
.submit_form_count_minus, .submit_form_count_plus {
    width: 22px;
    height: 22px;
    border-radius: 24px;
    border: 1px solid #FF0000;
    position: relative;
    cursor: pointer;
}
.submit_form_count_minus:before, .submit_form_count_plus:before, .submit_form_count_plus:after {
    content: "";
    display: block;
    width: 14px;
    height: 2px;
    background: #FF0000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.submit_form_count_plus:after {
    transform: translate(-50%, -50%) rotate(90deg);
}
.submit_form_count_item {
    font-weight: 500;
    font-size: 18px;
    line-height: 17px;
    color: #404455;
    width: 85px;
}
.hidden_button {
    position: absolute;
    height: 100px;
    width: 100px;
    border: 0px solid black;
    margin-left: -100px;
    opacity: 0;
}
</style>
<script>
    import { mutations, responsiveClass, track, goodsList, combinedArray, order} from '../mainStore.js';
    import config from '../config.js';
    import { onMount } from 'svelte';
    import TrackConstructor from '../Step3/MainTabs/TrackConstructor.svelte';
    import { MaskedInput } from 'svelte-imask';

    let count;
    let userEmail;
    let userPhone;
    let userName;
    let userComment;
    const options = {
		mask: '{+}{7}(000)000-00-00'
	};

    onMount(async () => {
        if($order.count) {
            count = $order.count
        } else {
            count = 1
        }
        if($order.userEmail) {
            userEmail = $order.userEmail
        }
        if($order.userPhone) {
            userPhone = $order.userPhone
        }
        if($order.userName) {
            userName = $order.userName
        }
        if($order.userComment) {
            userComment = $order.userComment
        }
    })

    async function send(event, hidden = false) {
        try {
            if (!hidden) {
                mutations.setPreloader(true)
            }
            let data = {};
            data ['items'] = getItems();
            data ['email'] = userEmail;
            data ['phone'] = userPhone;
            data ['track_id'] = $track.id;
            data ['track_bitrix_id'] = $track.bitrix_id;
            data ['name'] = userName;
            data ['comment'] = userComment;
            data ['color'] = $track.colorCode;
            data ['count'] = count;
            data ['id'] = $order.id;
            data ['hidden'] = hidden;
            const response = await fetch(config.backUrl+'/api/saveOrder', {
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    body: JSON.stringify(data)
            });
            if (hidden) {
                let orderResp = await response.json()
                copyUrl(orderResp.id)
            } else {
                mutations.setStep(5)
                mutations.setPreloader(false)
            }
        }
        catch (e){
            mutations.setPreloader(false)
            console.log(e)
        }
    }

    function copyUrl(id) {
        copyText.style = "display: block;"
        copyText.value = config.frontUrl + "/?s_order_enk=" + id
        copyText.select();
        document.execCommand("copy");
        copyText.style = "display: none;"
    }

    function getItems() {
        let result = []
        for (let item of $goodsList) {
            result.push({
                id: item.id,
                bitrix_id: item.bitrix_id,
                tabName: item.tabName,
                x: item.x,
                onTop: item.onTop,
                position: item.position,
            })
        }
        return result
    }

    function prev() {
        mutations.setStep(3)
    }
    function minus() {
        if (count > 1) {
            count--
        }
    }
    function plus() {
        count++
    }
    $: mutations.setOrder({
        id: $order.id,
        bitrix_id: $order.order_bitrix_id,
        userEmail: userEmail ? userEmail : $order.userEmail,
        userPhone: userPhone ? userPhone : $order.userPhone,
        userName: userName ? userName : $order.userName,
        userComment: userComment ? userComment : $order.userComment,
        count: count ? count : $order.count,
    })
    let copy = ""
    function clean_value(e){
        e.target.value =  e.target.value.replace(/[^\d]/g,'');
    }
</script>
<div class="hidden_button" on:click={(event) => send(event, true)}></div>
<input type="text" style="display: none;" id="copyText" bind:value={copy}>
<form class="submit_info {$responsiveClass}" on:submit|preventDefault={(event) => send(event)}>

    <div class="submit_title">
        Ваш трак готов!<br>
        Отправьте его нам и <br>
        мы посчитаем<br>
        стоимость для вас!
    </div>

    <TrackConstructor index={0} readOnly={true} />

    <div class="submit_form_count_area">
        <div class="submit_form_count_title">Количество</div>
        <div class="submit_form_count">
            <div class="submit_form_count_minus" on:click={minus}></div>
            <div class="submit_form_count_item">{count}</div>
            <div class="submit_form_count_plus" on:click={plus}></div>
        </div>
    </div>

    <div class="submit_form_inputs">

        <MaskedInput id="user_phone" bind:value={userPhone} name="user_phone" placeholder="+7(999)999-99-99*" type="tel" {options} required />

        <input type="text" name="user_name" id="user_name" bind:value={userName} placeholder="Имя*" required>

        <input type="email" name="user_email" id="user_email" bind:value={userEmail} placeholder="E-mail*" required>

        <textarea rows="7" name="user_comment" id="user_comment" bind:value={userComment} placeholder="Комментарий" ></textarea>
        <div class="button_container">
            <a href="#step3">
                <button class="submit_btn submit_btn_prev" type="button" on:click={prev}>Назад</button>
            </a>
            <a href="#step5">
                <button class="submit_btn" type="submit">Отправить</button>
            </a>
        </div>
    </div>
</form>
